interface IMoneyFormatOptions {
  style?: 'currency' | 'decimal'
  currency?: string
  hasDecimals?: boolean
}

export function formatMoney(
  centsValue: number,
  options?: IMoneyFormatOptions,
): string {
  const hasDecimals = options?.hasDecimals ?? true
  const value = hasDecimals ? centsValue / 100 : centsValue

  const currency = options?.currency || 'BRL'

  try {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency,
      ...options,
    }).format(value)
  } catch (error) {
    console.warn(
      `Currency ${currency} not supported, falling back to decimal format: ${error}`,
    )
    return new Intl.NumberFormat('pt-BR', {
      style: 'decimal',
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0,
    }).format(value)
  }
}
